import { usePermissionsStore } from "@/stores/permissions-store";

export const useHasRootPriviliges = () => {
  const hasRootPrivileges = usePermissionsStore((state) => state.hasRootPrivileges);
  const isLoading = usePermissionsStore((state) => state.isLoading);

  return {
    hasRootPriviliges: hasRootPrivileges,
    isLoading,
    isFetching: isLoading,
  };
};
